module.exports = __webpack_public_path__ + "school/img/campus_health_detail_bg.ecfeab91.png";